export function createIconName(title: string): string {
  const match = title
    .replace(/_/g, ' ')
    .match(/\w+/g);

  return match
    ? match.slice(0, 2).map(w => w.charAt(0)).join('')
    : '';
}
